function calculateValues(form: HTMLFormElement) {
	const values = new Map<string, number>();

	const realIdentifier = (identifier: string, context: HTMLElement|number) => {
		if (typeof context === 'number') {
			return `${identifier}${context}`;
		}
		return context instanceof HTMLTableElement ? `${identifier}${parseInt(context.dataset['tableNumber'])}` : identifier;
	};
	const get = (identifier: string, context: HTMLElement|number) => {
		const actualIdentifier = realIdentifier(identifier, context);
		if (values.has(actualIdentifier)) {
			return values.get(actualIdentifier)!;
		} else {
			const value = Number(form.querySelector<HTMLInputElement|HTMLOutputElement>(`.${actualIdentifier}`).value);
			values.set(actualIdentifier, value);
			return value;
		}
	};
	const display = (identifier: string, value: number, context: HTMLTableElement|number, decimalRetainer?: number) => {
		values.set(realIdentifier(identifier, context), value);
		const displayValue = decimalRetainer ? Math.round(value * Math.pow(10, decimalRetainer)) / Math.pow(10, decimalRetainer) : Math.round(value);
		form.querySelector<HTMLOutputElement>(`.${realIdentifier(identifier, context)}`).value = displayValue.toString();
		return value;
	};

	type ForTableResult = { get: (identifier: string, context?: HTMLElement|number) => number, display: (identifier: string, value: number, detailRetainer?: number) => number };
	const forTable = (table: HTMLTableElement): ForTableResult => {
		const ctx = parseInt(table.dataset['tableNumber']);
		return {
			get: (identifier, context) => get(identifier, context ?? ctx),
			display: (identifier, value, detailRetainer) => display(identifier, value, ctx, detailRetainer)
		};
	};

	form.querySelectorAll<HTMLTableElement>('.resistiveLoadBankRatings').forEach(table => {
		const {display, get} = forTable(table);
		display('lblAmps', (get('kw') * 1000) / (get('volts') * Math.sqrt(get('phase')) * get('pf')));
	});

	form.querySelectorAll<HTMLTableElement>('.resistiveLoadBankDeratings').forEach(table => {
		const {display, get} = forTable(table);
		const priorTable = parseInt(table.dataset['tableNumber']) - 1;
		const volts = get('volts');
		const kw = display('kw', (Math.pow(volts, 2) / Math.pow(get('volts', priorTable), 2)) * get('kw', priorTable));
		display('lblAmps', (kw * 1000) / (volts * Math.sqrt(get('phase')) * get('pf')));
	});

	const updateSecondHalfOfResistiveInductiveLoadBankTables = (table: HTMLTableElement, hertz: number, kw: number, kvar: number, volts: number) => {
		const {display, get} = forTable(table);
		display('pf', kw / Math.sqrt(Math.pow(kw, 2) + Math.pow(kvar, 2)), 2);
		display('hertz', hertz);
		const rAmps = display('ramps', (kw * 1000) / (volts * Math.sqrt(get('phase'))));
		const iAmps = display('iamps', (kvar * 1000) / (volts * Math.sqrt(get('phase'))));

		const sysAmps = display('sysamps', Math.sqrt(Math.pow(rAmps, 2) + Math.pow(iAmps, 2)));
		display('syskva', volts * sysAmps * Math.sqrt(get('phase')) / 1000);
	};

	form.querySelectorAll<HTMLTableElement>('.resistiveInductiveLoadBankRatings').forEach(table => {
		const {display, get} = forTable(table);
		const baseTable = parseInt(table.dataset['tableNumber']) - 2;
		const kw = display('kw', get('kw', baseTable));
		const kvar = display('kvar', kw * 0.75);
		const volts = display('volts', get('volts', baseTable));
		updateSecondHalfOfResistiveInductiveLoadBankTables(table, get('hertz', baseTable), kw, kvar, volts);
	});
	form.querySelectorAll<HTMLTableElement>('.resistiveInductiveLoadBankDeratings').forEach(table => {
		const {display, get} = forTable(table);
		const priorTable = parseInt(table.dataset['tableNumber']) - 1;
		const volts = display('volts', get('volts', priorTable - 1));
		const hertz = display('hertz', get('hertz', priorTable - 1));

		const kw = display('kw', Math.pow(get('volts'), 2) / Math.pow(get('volts', priorTable), 2) * get('kw', priorTable));
		const kvar = display('kvar', get('kvar', priorTable) * (get('hertz', priorTable) / hertz)
			* (Math.pow(get('volts'), 2) / Math.pow(get('volts', priorTable), 2)));
		updateSecondHalfOfResistiveInductiveLoadBankTables(table, hertz, kw, kvar, volts);
	});
}

const setUpForms = (node: ParentNode) => {
	node.querySelectorAll<HTMLFormElement>('.loadBanksDeratingTool form:not(.setUp)').forEach(form => {
		form.classList.toggle('setUp', true);
		calculateValues(form);
		form.querySelectorAll('input').forEach(input => {
			input.addEventListener('keyup', () => calculateValues(form));
			input.addEventListener('change', () => calculateValues(form));
		});
	});
};
setUpForms(document.body);

new MutationObserver(mutations => {
	for (const mutation of mutations) {
		mutation.addedNodes.forEach(node => {
			if (node instanceof Element) {
				setUpForms(node);
			}
		});
	}
}).observe(document.body, {subtree: true, childList: true});
